<template>
    <div id="customFieldModal" class="modal" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-lg">{{ form.name ? form.name : 'New Custom Field' }}</h4>
                    <button type="button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal" @click="closeModal()">close
                    </button>
                </div>
                <div class="modal-body">
                    <form @keydown="form.errors.clear($event.target.name)">
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="name"
                                    :class="{'text-red': form.errors.has('name')}">Name</label>
                            <input v-model="form.name" id="name" name="name"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('name')}" v-if="openModalFor == 'new'">
                            <span class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full d-flex cursor-not-allowed" style="opacity:0.7" v-else>{{form.name}}</span>
                            <div class="text-red text-xs" v-if="form.errors.has('name')">
                                {{ form.errors.get('name') }}
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="type"
                                    :class="{'text-red': form.errors.has('type')}">Type</label>
                            <div>
                                <select name="" id=""
                                    class="bg-white border-1 focus:outline-none px-2 text-grey-darkest text-sm"
                                    v-model="form.type">
                                    <option default></option>
                                    <option value="1">User</option>
                                    <option value="2">Text</option>
                                    <option value="3">DropDown</option>
                                    <option value="4">Date</option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('type')">{{
                                    form.errors.get('type') }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="label_value"
                                    :class="{'text-red': form.errors.has('name')}">Display label</label>
                            <input v-model="form.label_value" id="label_value" name="label_value"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('label_value')}">
                            <div class="text-red text-xs" v-if="form.errors.has('label_value')">
                                {{ form.errors.get('label_value') }}
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="load_order"
                                    :class="{'text-red': form.errors.has('name')}">Load Order</label>
                            <div>
                                <input v-model="form.load_order" id="load_order" name="load_order" type="number"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-1/2"
                                    :class="{'border-red': form.errors.has('load_order')}">
                                <div class="text-red text-xs" v-if="form.errors.has('load_order')">
                                    {{ form.errors.get('load_order') }}
                                </div>
                            </div>
                        </div>
                        <div class="flex py-1">
                            <input v-model="form.enabled" id="enabled" name="enabled" type="checkbox"
                                   class="bg-white border-1"
                                   :class="{'border-red': form.errors.has('enabled')}">
                            <label class="text-sm text-grey-darkest px-1 mb-0" for="enabled"
                                    :class="{'text-red': form.errors.has('enabled')}">Enabled</label>
                        </div>
                        <div class="text-red text-xs" v-if="form.errors.has('enabled')">
                            {{ form.errors.get('enabled') }}
                        </div>
                        <div class="d-flex" v-if="team && team.foundation_db_connection_detail">
                            <div>
                                <div class="d-flex align-items-center">
                                    <input v-model="form.is_project_custom_id" id="is_project_custom_id" name="is_project_custom_id" type="checkbox"
                                           class="bg-white border-1 px-2"
                                           :class="{'border-red': form.errors.has('is_project_custom_id')}">
                                    <label class="text-sm text-grey-darkest px-1 mb-0 px-2" for="is_project_custom_id"
                                           :class="{'text-red': form.errors.has('is_project_custom_id')}">Custom Job #</label>
                                </div>
                                <div class="text-red text-xs" v-if="form.errors.has('is_project_custom_id')">
                                    {{ form.errors.get('is_project_custom_id') }}
                                </div>
                            </div>
                            <div v-if="form.is_project_custom_id">
                                <div class="d-flex px-2 align-items-center">
                                    <input v-model="form.is_foundation_id_auto_generated" id="is_foundation_id_auto_generated" name="is_foundation_id_auto_generated" type="checkbox"
                                           class="bg-white border-1 px-2"
                                           :class="{'border-red': form.errors.has('is_foundation_id_auto_generated')}">
                                    <label class="text-sm text-grey-darkest mb-0 px-2" for="is_foundation_id_auto_generated"
                                           :class="{'text-red': form.errors.has('is_foundation_id_auto_generated')}">Auto-Generate Foundation Job # (N/A for alpha-numeric)</label>
                                </div>
                                <div class="text-red text-xs" v-if="form.errors.has('is_foundation_id_auto_generated')">
                                    {{ form.errors.get('is_foundation_id_auto_generated') }}
                                </div>
                            </div>
                        </div>
                        <div v-if="team && team.foundation_db_connection_detail" class="flex py-1">
                            <input v-model="form.is_foundation_project_manager" id="is_foundation_project_manager" name="is_foundation_project_manager" type="checkbox"
                                   class="bg-white border-1"
                                   :class="{'border-red': form.errors.has('is_foundation_project_manager')}">
                            <label class="text-sm text-grey-darkest px-1 mb-0" for="is_foundation_project_manager"
                                   :class="{'text-red': form.errors.has('is_foundation_project_manager')}">Foundation Project Manager</label>
                        </div>
                        <div class="text-red text-xs" v-if="form.errors.has('is_foundation_project_manager')">
                            {{ form.errors.get('is_foundation_project_manager') }}
                        </div>
                        <div class="flex py-1">
                            <input v-model="form.is_dead_reason_field" id="is_dead_reason_field" name="is_dead_reason_field" type="checkbox"
                                   class="bg-white border-1"
                                   :class="{'border-red': form.errors.has('is_dead_reason_field')}">
                            <label class="text-sm text-grey-darkest px-1 mb-0" for="is_dead_reason_field"
                                   :class="{'text-red': form.errors.has('is_dead_reason_field')}">Link to dead status and dead recap report</label>
                        </div>
                        <div class="text-red text-xs" v-if="form.errors.has('is_dead_reason_field')">
                            {{ form.errors.get('is_dead_reason_field') }}
                        </div>

                        <div v-if="form.type == '2'">
                            <div class="d-flex align-items-center">
                                <input v-model="form.spectrum_project_custom_id_auto_generated" id="spectrum_project_custom_id_auto_generated" name="spectrum_project_custom_id_auto_generated" type="checkbox"
                                       class="bg-white border-1 px-2"
                                       :class="{'border-red': form.errors.has('spectrum_project_custom_id_auto_generated')}" >
                                <label class="text-sm text-grey-darkest mb-0 px-2" for="spectrum_project_custom_id_auto_generated"
                                       :class="{'text-red': form.errors.has('spectrum_project_custom_id_auto_generated')}">Spectrum Auto-Generated</label>
                            </div>
                            <div class="text-red text-xs" v-if="form.errors.has('spectrum_project_custom_id_auto_generated')">
                                {{ form.errors.get('spectrum_project_custom_id_auto_generated') }}
                            </div>
                            <div v-if="form.spectrum_project_custom_id_auto_generated" class="text-grey-darkest bg-white border-0">
                                <div class="card m-0">
                                    <div class="card-body">
                                        <draggable
                                            draggable=".item"
                                            :element="'ul'"
                                            handle=".handle"
                                            :list="form.spectrum_project_custom_id_data"
                                            @start="drag = true"
                                            @end="drag = false">
                                            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                <li class="item"
                                                    v-for="(column, index) in form.spectrum_project_custom_id_data"
                                                    draggable='true'
                                                    :key="column.id">
                                                    <i class="fa fa-align-justify handle"></i>
                                                    <b-form-checkbox @change="changeCheck(column.id)" :disabled="column.id == 'system_generated'"
                                                                     v-model="column.value"
                                                    >
                                                        {{ column.label }}
                                                    </b-form-checkbox>
                                                    <ul>
                                                        <div v-if="column.input_type === 1">
                                                            <li>
                                                                <b-form-checkbox :class="column.sequential_class"
                                                                                 v-model="column.sequential" :disabled="column.sequential"
                                                                                 @change="changeState(column.sequential_class,column.id)"
                                                                >Sequential
                                                                </b-form-checkbox>
                                                            </li>
                                                            <li>
                                                                <div class="form-check form-inline" style="padding: 0px;">
                                                                    <b-form-checkbox :class="column.start_from_class" :disabled="column.start_from"
                                                                                     @change="changeState(column.start_from_class,column.id)"
                                                                                     v-model="column.start_from"
                                                                    >Start From #
                                                                    </b-form-checkbox>
                                                                    <span class="ml-2" style="width: 200px">
                                                                        <div v-if="column.id === 'year'">
                                                                            <b-form-input size="sm" v-model="column.input_value"
                                                                                          type="number" placeholder="2000"
                                                                                          :disabled="column.condition"
                                                                                          style="width: 90% !important;"></b-form-input>
                                                                        </div>
                                                                        <div v-else-if="column.id === 'month'">
                                                                            <b-form-input size="sm" v-model="column.input_value"
                                                                                          type="number" min="1" max="12"
                                                                                          placeholder="12" :disabled="column.condition"
                                                                                          style="width: 90% !important;"></b-form-input>
                                                                        </div>
                                                                        <div v-else-if="column.id === 'day'">
                                                                            <b-form-input size="sm" v-model="column.input_value"
                                                                                          type="number" min="1" max="31"
                                                                                          placeholder="31" :disabled="column.condition"
                                                                                          style="width: 90% !important;"></b-form-input>
                                                                        </div>
                                                                        <div v-else-if="column.id === 'system_generated'">
                                                                            <b-form-input size="sm" v-model="column.input_value"
                                                                                          type="number" placeholder="1000"
                                                                                          :disabled="column.condition"
                                                                                          style="width: 90% !important;"></b-form-input>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        </div>
                                                        <div v-else>
                                                            <li>
                                                                <b-form-checkbox :class="column.sequential_class" :disabled="column.disable"
                                                                                 v-model="column.seperated_by_dash"
                                                                                 @change="changeState(column.sequential_class,column.id)"
                                                                >Seperated by Dash
                                                                </b-form-checkbox>
                                                            </li>
                                                            <li>
                                                                <b-form-checkbox :class="column.start_from_class"
                                                                                 v-model="column.seperated_by_space" :disabled="column.disable"
                                                                                 @change="changeState(column.start_from_class,column.id)"
                                                                >Seperated by Space
                                                                </b-form-checkbox>
                                                            </li>
                                                        </div>
                                                    </ul>
                                                </li>
                                            </transition-group>
                                        </draggable>
                                    </div>
                                    <div class="card-footer">
                                        <span>{{ this.customProjectId }}</span>
                                    </div>
                                </div>

                            </div>
                        </div>



                    </form>
                </div>
                <div class="modal-footer">
                    <button @click.prevent="saved"
                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                        Save
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import draggable from 'vuedraggable';
import {spectrumCustomProjectIDState} from "../../../constants";

    export default {
        name: 'custom-field-modal',
        components: {draggable},
        props: ['team', 'customFields', 'customProjectIdState'],
        data() {

            let newState = spectrumCustomProjectIDState
            return {
                form: new Form({
                    id: '',
                    name: '',
                    type: '',
                    label_value: '',
                    load_order: '',
                    enabled: false,
                    label_view: false,
                    is_project_custom_id: false,
                    is_foundation_id_auto_generated: false,
                    is_foundation_project_manager: false,
                    is_dead_reason_field: false,
                    spectrum_project_custom_id_auto_generated: false,
                    spectrum_project_custom_id_data: newState,
                }),
                openModalFor:'new',
                drag: false,
                customProjectId: '',
                options: newState,
            }
        },
        watch: {
            'form.is_project_custom_id': function(value) {
                if(!value) {
                    this.form.is_foundation_id_auto_generated = false;
                }
            },
            'form.spectrum_project_custom_id_data': {
                handler: function (val, oldVal) {
                    this.previewCustomId();
                },
                deep: true
            },
            customProjectId: {
                handler: function (val, oldVal) {
                    this.customIdDigitLimitAllow();
                }
            }
        },
        created() {
            this.previewCustomId();
        },
        methods: {
            open(custom_field = null) {
                $(this.$el).modal('show');
                if (custom_field) {
                    if(custom_field.spectrum_project_custom_id_data){
                        this.options = custom_field.spectrum_project_custom_id_data;
                    }
                    this.form.id = custom_field.id;
                    this.form.name = custom_field.name;
                    this.form.type = custom_field.type;
                    this.form.label_value = custom_field.label_value;
                    this.form.load_order = custom_field.load_order;
                    this.form.enabled = custom_field.enabled;
                    this.form.label_view = custom_field.enabled;
                    this.form.is_project_custom_id = custom_field.is_project_custom_id;
                    this.form.is_foundation_id_auto_generated = custom_field.is_foundation_id_auto_generated;
                    this.form.is_foundation_project_manager = custom_field.is_foundation_project_manager;
                    this.form.is_dead_reason_field = custom_field.is_dead_reason_field;
                    this.openModalFor = 'edit';
                    this.form.spectrum_project_custom_id_auto_generated = custom_field.spectrum_project_custom_id_auto_generated;
                    this.form.spectrum_project_custom_id_data = custom_field.spectrum_project_custom_id_data ?? this.options;
                } else {
                    this.form.reset();
                    this.form.enabled = false;
                    this.form.label_view = false;
                    this.form.is_project_custom_id = false;
                    this.form.is_foundation_id_auto_generated = false;
                    this.form.is_foundation_project_manager = false;
                    this.form.is_dead_reason_field = false;
                    this.openModalFor = 'new';
                    this.form.spectrum_project_custom_id_auto_generated = false;
                    this.form.spectrum_project_custom_id_data = this.options;
                }
            },

            saved() {
                let self = this;
                self.form.label_view = self.form.enabled;
                let custom_field = _.find(self.customFields, { 'spectrum_project_custom_id_auto_generated': 1 });
                if (this.form.id) {
                    if (custom_field && this.form.spectrum_project_custom_id_auto_generated && this.form.id != custom_field.id ){
                        Swal.fire({
                            title: "ERROR",
                            text: "Team already has a custom field for project custom id",
                            confirmButtonColor: 'red',
                            dangerMode: true,
                        });
                        return;
                    }
                    this.form.put(route('api.project-custom-field.update',  this.form.id)).then(() => {
                        $("#customFieldModal").modal("hide");
                        self.$emit('saved', {'payload':true});
                        self.closeModal();
                    });
                } else {
                    if (custom_field && this.form.spectrum_project_custom_id_auto_generated){
                        Swal.fire({
                            title: "ERROR",
                            text: "Team already has a custom field for project custom id",
                            confirmButtonColor: 'red',
                            dangerMode: true,
                        });
                        return;
                    }
                    this.form.post(route('api.project-custom-field.store')).then(() => {
                        $("#customFieldModal").modal("hide");
                        self.$emit('saved', {'payload':true});
                        self.closeModal();
                    });
                }
            },
            closeModal() {
                let self = this;
                self.form.errors.errors = {};
            },
            changeCheck(idName) {
                let newState = this.options;
                const targetIndex = newState.findIndex(f => f.id === idName);
                if (idName == "year" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = true;
                    if (idName == "year" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "year" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                }
                if (idName == "year" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = false;
                    if (idName == "year" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "year" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = false;
                    }
                }
                if (idName == "month" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = true;
                    if (idName == "month" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "month" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                }
                if (idName == "month" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = false;
                    if (idName == "month" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "month" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = false;
                    }
                }
                if (idName == "day" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = true;
                    if (idName == "day" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "day" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                }
                if (idName == "day" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = false;
                    if (idName == "day" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "day" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = false;
                    }
                }
                if (idName == "system_generated" && newState[targetIndex].value == true && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = true;
                    if (idName == "system_generated" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "system_generated" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                }
                if (idName == "system_generated" && newState[targetIndex].value == false && newState[targetIndex].input_type == 1){
                    newState[targetIndex].disable = false;
                    if (idName == "system_generated" && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = true;
                    }
                    if (idName == "system_generated" && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                        newState[targetIndex].condition = false;
                    }
                }
                if (idName == "other" && newState[targetIndex].value == true && newState[targetIndex].input_type == 0){
                    newState[targetIndex].disable = true;
                }
                if (idName == "other" && newState[targetIndex].value == false && newState[targetIndex].input_type == 0){
                    newState[targetIndex].disable = false;
                }
            },
            changeState(className, idName) {
                let newState = this.options;
                const targetIndex = newState.findIndex(f => f.id === idName);

                if (className == 'start_from_' + newState[targetIndex].id && newState[targetIndex].sequential == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].sequential = false;
                    newState[targetIndex].start_from = true;
                    newState[targetIndex].condition = false;
                }
                if (className == 'sequential_' + newState[targetIndex].id && newState[targetIndex].start_from == true && newState[targetIndex].input_type == 1) {
                    newState[targetIndex].sequential = true;
                    newState[targetIndex].start_from = false;
                    newState[targetIndex].condition = true;
                }
                if (className == 'start_from_' + newState[targetIndex].id && newState[targetIndex].seperated_by_dash == true && newState[targetIndex].input_type == 0) {
                    newState[targetIndex].seperated_by_dash = false;
                    newState[targetIndex].seperated_by_space = true;
                }
                if (className == 'sequential_' + newState[targetIndex].id && newState[targetIndex].seperated_by_space == true && newState[targetIndex].input_type == 0) {
                    newState[targetIndex].seperated_by_dash = true;
                    newState[targetIndex].seperated_by_space = false;
                }
            },
            previewCustomId() {
                let newState = this.options;
                const customId = [];
                let other = '';
                for (const element of newState) {
                    switch (element.id) {
                        case 'year':
                            if (element.value === true) {
                                if (element.sequential === true) {
                                    let year = new Date().getFullYear();
                                    customId.push(year);
                                } else if (element.start_from === true) {
                                    let year = element.input_value;
                                    customId.push(year);
                                }
                            }
                            break;
                        case 'month':
                            if (element.value === true) {
                                if (element.sequential === true) {
                                    let month = new Date().getMonth() + 1;
                                    customId.push(month);
                                } else if (element.start_from === true) {
                                    let month = element.input_value;
                                    customId.push(month);
                                }
                            }
                            break;
                        case 'day':
                            if (element.value === true) {
                                if (element.sequential === true) {
                                    let day = new Date().getDate();
                                    customId.push(day);
                                } else if (element.start_from === true) {
                                    let day = element.input_value;
                                    customId.push(day);
                                }
                            }
                            break;
                        case 'system_generated':
                            if (element.value === true) {
                                if (element.sequential === true) {
                                    let system_generated = Math.floor(element.input_value);
                                    customId.push(system_generated);
                                } else if (element.start_from === true) {
                                    let system_generated = element.input_value;
                                    customId.push(system_generated);
                                }
                            }
                            break;
                        case 'other':
                            if (element.value === true) {
                                if (element.seperated_by_dash === true) {
                                    other = '-';
                                } else if (element.seperated_by_space === true) {
                                    other = '/';
                                } else {
                                    other = '';
                                }
                            } else {
                                other = '';
                            }
                            break;
                    }
                }
                if (other == '-') {
                    var idProject = customId.join("-");
                }
                if (other == '/') {
                    var idProject = customId.join(" ");
                }
                if (other == '') {
                    var idProject = customId.join("");
                }
                this.customProjectId = idProject;
            },
            customIdDigitLimitAllow() {
                return this.customProjectId.length > 10;
            }
        }
    }
</script>
